import React from "react";

export default function TextInput({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  disabled = false,
  required = false,
  width = "100%",
  maxWidth = "100%",
  type = "text",
}) {
  return (
    <label style={{ display: "grid", gap: 6, width }}>
      {label && (
        <span style={{ color: "white", fontSize: 14 }}>
          {label} {required && <span style={{ color: "#f87171" }}>*</span>}
        </span>
      )}

      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        style={{
          width: "100%",
          maxWidth,

          padding: "8px 12px",

          borderRadius: 8,

          border: "1px solid rgba(255,255,255,0.15)",

          background: "linear-gradient(180deg, #1f2937 0%, #111827 100%)",

          color: "white",

          outline: "none",

          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.4)",

          fontFamily: "inherit",
          fontSize: 14,

          transition: "all 0.15s ease",

          opacity: disabled ? 0.6 : 1,
        }}

        onFocus={(e) => {
          e.target.style.border = "1px solid #3b82f6";
          e.target.style.boxShadow = "0 0 0 1px rgba(59,130,246,0.3)";
        }}

        onBlur={(e) => {
          e.target.style.border = "1px solid rgba(255,255,255,0.15)";
          e.target.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.4)";
        }}
      />
    </label>
  );
}